import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';

import studentServices from '../../../../../services/academy/studentsServices';

export default function FilterBillsPopUp(props) {
    const [students, setStudents] = useState([]);

    const [filterFields, setFilterFields] = useState({
        centro_de_custo: "",
        parceiro: "",
        data_venc: "",
        status: "Não Pagas",
    });

    const getStudents = async () => {
        try {
            const response = await studentServices.getStudents();
            setStudents(response.data);
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getStudents();
    }, []);

    useEffect(() => {
        if(props.bills.length > 0)
            onFilter();
    }, [props.bills]);


    function onFilter() {
        let auxArray = [...props.bills];

        if(filterFields.centro_de_custo !== "") {
            auxArray = auxArray.filter(obj => obj.centro_de_custo === filterFields.centro_de_custo);
        }

        if(filterFields.parceiro !== "") {
            auxArray = auxArray.filter(obj => obj.parceiro === filterFields.parceiro);
        }


        if(filterFields.data_venc !== "") {
            auxArray = auxArray.filter(obj => obj.data_venc <= filterFields.data_venc);
        }

        if(filterFields.status === "Não Pagas") {
            auxArray = auxArray.filter(obj => obj.paga === false);
        }

        else if(filterFields.status === "Pagas") {
            auxArray = auxArray.filter(obj => obj.paga === true);
        }

        else{
            auxArray = auxArray.filter(obj => obj.paga === false || true);
        }

        props.setBills(auxArray);
    }

    function onResetFilters() {
        setFilterFields({
            centro_de_custo: "",
            parceiro: "",
            forma_de_pagamento: "",
            data_venc: "",
            status: "Não Pagas",
        });
    }

    function isReseted() {
        for(const key of Object.keys(filterFields)) {
            if (key === "status" && filterFields[key] !== "Não Pagas"){
                return false;                
            }
            else if(key !== "status" && filterFields[key])
                return false;
        }
        return true;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='bills-filter-container'>

                <Input
                label="Cliente"
                type="select"
                options={students.map(obj => obj.nome + " " + obj.sobrenome)}
                placeholder='Insira o nome de um cliente'
                id="bills-filter-partner"
                onChange={(e) => setFilterFields({...filterFields, parceiro: e.target.value})}
                cleanValue=""
                value={filterFields.parceiro}
                />

                <Input
                label="Centro de Custo"
                placeholder='Insira um Centro de Custo'
                id="bills-filter-cost-center"
                onChange={(e) => setFilterFields({...filterFields, centro_de_custo: e.target.value})}
                cleanValue=""
                value={filterFields.centro_de_custo}
                />



                    <Input
                    label="Vencimento máx."
                    type="date"
                    id="bills-filter-due-date"
                    onChange={(e) => setFilterFields({...filterFields, data_venc: e.target.value})}
                    cleanValue=""
                    value={filterFields.data_venc}
                    />


                <Input
                    label="Status"
                    type="select"
                    noFilterOptions
                    id="bills-filter-status"
                    options={["Todos", "Pagas", "Não Pagas"]}
                    onChange={(e) => setFilterFields({...filterFields, status: e.target.value})}
                    value={filterFields.status}
                />
            </div>
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}